/**
 * This implementation is taken from react-leaflet-freedraw.
 * The original npm package isn't used because it seems to be stale and abandoned.
 *
 * @link https://www.npmjs.com/package/react-leaflet-freedraw
 * @link https://github.com/elangobharathi/react-leaflet-freedraw
 */
import { createLayerComponent } from '@react-leaflet/core';
import LeafletFreedraw from 'leaflet-freedraw';
function createLeafletElement(props, context) {
    const instance = new LeafletFreedraw({ ...props });
    return { instance, context: { ...context, overlayContainer: instance } };
}
function updateLeafletElement(instance, props, prevProps) {
    if (props.mode !== prevProps.mode) {
        instance.mode(props.mode);
    }
}
const FreedrawControl = createLayerComponent(createLeafletElement, updateLeafletElement);
export default FreedrawControl;
